const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8003';

// Guardar token en localStorage
export function setToken(token) {
  localStorage.setItem('auth_token', token);
}

// Obtener token de localStorage
export function getToken() {
  return localStorage.getItem('auth_token');
}

// Eliminar token (logout)
export function removeToken() {
  localStorage.removeItem('auth_token');
}

// Verificar si hay usuario autenticado
export function isAuthenticated() {
  return !!getToken();
}

// Decodificar token
export function decodeToken(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(c => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error decodificando token:', error);
    return null;
  }
}

// Obtener empresa_id del token actual
export function getEmpresaIdFromToken() {
  const token = getToken();
  if (!token) return null;
  const decoded = decodeToken(token);
  return decoded?.empresa_id || null;
}

// Obtener rol del token actual
export function getRolFromToken() {
  const token = getToken();
  if (!token) return null;
  const decoded = decodeToken(token);
  return decoded?.rol || null;
}

// Función auxiliar para obtener headers (con ngrok fix)
function getHeaders(extraHeaders = {}) {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    'ngrok-skip-browser-warning': 'true',
    ...extraHeaders
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
}

// Login (usa OAuth2PasswordRequestForm con x-www-form-urlencoded)
export async function login(credentials) {
  const formData = new URLSearchParams();
  formData.append('username', credentials.username);
  formData.append('password', credentials.password);

  const response = await fetch(`${API_URL}/api/v1/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'ngrok-skip-browser-warning': 'true',
    },
    body: formData,
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al iniciar sesión');
  }

  const data = await response.json();
  setToken(data.access_token);
  return data;
}

// Logout
export function logout() {
  removeToken();
  window.location.href = '/login';
}

// Header de autorización (mantenido por compatibilidad)
export function authHeader() {
  const token = getToken();
  const headers = { 'ngrok-skip-browser-warning': 'true' };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
}

// ============================================================
// NUEVAS FUNCIONES PARA RECUPERACIÓN DE CONTRASEÑA
// ============================================================

export async function solicitarRecuperacion(email) {
  const response = await fetch(`${API_URL}/api/v1/auth/recuperar`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'ngrok-skip-browser-warning': 'true',
    },
    body: JSON.stringify({ email }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al solicitar recuperación');
  }

  return response.json();
}

export async function restablecerPassword(token, nuevaPassword) {
  const response = await fetch(`${API_URL}/api/v1/auth/restablecer`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'ngrok-skip-browser-warning': 'true',
    },
    body: JSON.stringify({ token, nueva_password: nuevaPassword }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al restablecer la contraseña');
  }

  return response.json();
}

// Obtener nombre del usuario desde el token actual
export function getNombreFromToken() {
  const token = getToken();
  if (!token) return null;
  const decoded = decodeToken(token);
  return decoded?.nombre || decoded?.name || decoded?.full_name || decoded?.email || 'Usuario';
}